export const ACCOUNT_BUSINESS_REGION_OF_OPERATIONS = Object.freeze({
  AFRICA: 'Africa',
  ASIA: 'Asia',
  EUROPE: 'Europe',
  LATIN_AMERICA: 'Latin America',
  USA_AND_CANADA: 'USA and Canada',
});
